export default __webpack_public_path__ + "static/media/Music_14.7bb48d82.png";